import React, { useContext } from "react"
import "./RecipesFilterStyle.css"
import Row from "react-bootstrap/Row"
import Container from "react-bootstrap/Container"
import Col from "react-bootstrap/Col"
import { MyContext } from "../Recipes"

//filters
import DropFilter from "./DropFilter"
import CheckboxesFilter from "./CheckboxesFilter"
import RangeSliderFilter from "./RangeSliderFilter"
//filters lists
import { cuisines } from "./filters Lists/CuisinesList"
import { diets } from "./filters Lists/DietsList"
import { mealtypes } from "./filters Lists/MealTypesList"
import { intolerances } from "./filters Lists/IntolerancesList"

function RecipesFilter() {
  const { searchBy, clearFilter } = useContext(MyContext)

  return (
    <Container className='filterContainer'>
      <Row>
        <Col className='colStyle'>
          <DropFilter
            searchBy={searchBy}
            clearFilter={clearFilter}
            list={cuisines}
            filterName='Cuisine'></DropFilter>
          <DropFilter
            searchBy={searchBy}
            clearFilter={clearFilter}
            list={diets}
            filterName='Diet'></DropFilter>
          <DropFilter
            searchBy={searchBy}
            clearFilter={clearFilter}
            list={mealtypes}
            filterName='Type'></DropFilter>
          <CheckboxesFilter
            searchBy={searchBy}
            clearFilter={clearFilter}
            list={intolerances}
            filterName='intolerances'></CheckboxesFilter>
          <RangeSliderFilter
            searchBy={searchBy}
            clearFilter={clearFilter}
            filterName='maxReadyTime'></RangeSliderFilter>
        </Col>
      </Row>
    </Container>
  )
}

export default RecipesFilter
